<template>
  <div>
    <h5 class="page-sub-title pl-2 pl-md-4 mt-3 mt-md-4">車庫承諾書取得</h5>
    <table class="table">
      <tr>
        <th>車庫承諾書取得のご希望</th>
        <td>
          <div class="row">
            <div class="col-md-3">
              <validation-provider
                v-slot="{ errors }"
                name="SYAKO_SYODAKUSYO_FLG"
              >
                <b-form-select
                  ref="SYAKO_SYODAKUSYO_FLG"
                  v-model="form.SYAKO_SYODAKUSYO_FLG"
                  :state="errors.length ? false : null"
                  :options="yesNoIraiList"
                  trim
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
          </div>
        </td>
      </tr>
    </table>

    <table v-if="form.SYAKO_SYODAKUSYO_FLG" class="table">
      <tr>
        <th>承諾書の取寄せ先</th>
        <td>
          <div class="row">
            <div class="col-md-3">
              <validation-provider
                v-slot="{ errors }"
                name="SYAKO_SYODAKUSYO_TORIYOSE_FLG"
              >
                <b-form-select
                  ref="SYAKO_SYODAKUSYO_TORIYOSE_FLG"
                  v-model="form.SYAKO_SYODAKUSYO_TORIYOSE_FLG"
                  :state="errors.length ? false : null"
                  :options="syakoSyodakusyoToriyoseList"
                  trim
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th>契約者名</th>
        <td>
          <validation-provider
            name="SYAKO_SYODAKUSYO_CHUSYAJYO_KEIYAKU_MEI"
            v-slot="{ errors }"
            rules="max:20|char"
          >
            <b-form-input
              ref="SYAKO_SYODAKUSYO_CHUSYAJYO_KEIYAKU_MEI"
              class="col-md-3"
              maxlength="20"
              v-model="form.SYAKO_SYODAKUSYO_CHUSYAJYO_KEIYAKU_MEI"
              :state="errors.length ? false : null"
              placeholder="田中太郎"
              trim
              @blur="
                form.SYAKO_SYODAKUSYO_CHUSYAJYO_KEIYAKU_MEI = replaceChar(
                  form.SYAKO_SYODAKUSYO_CHUSYAJYO_KEIYAKU_MEI
                )
              "
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr>
        <th>駐車場名</th>
        <td>
          <validation-provider
            name="SYAKO_SYODAKUSYO_CHUSYAJYO_MEI"
            v-slot="{ errors }"
            rules="max:20|char"
          >
            <b-form-input
              ref="SYAKO_SYODAKUSYO_CHUSYAJYO_MEI"
              class="col-md-8"
              maxlength="20"
              v-model="form.SYAKO_SYODAKUSYO_CHUSYAJYO_MEI"
              :state="errors.length ? false : null"
              placeholder=""
              trim
              @blur="
                form.SYAKO_SYODAKUSYO_CHUSYAJYO_MEI = replaceChar(
                  form.SYAKO_SYODAKUSYO_CHUSYAJYO_MEI
                )
              "
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr>
        <th>駐車場番号</th>
        <td>
          <validation-provider
            name="SYAKO_SYODAKUSYO_CHUSYAJYO_BANGO"
            v-slot="{ errors }"
            rules="max:4|numeric"
          >
            <b-form-input
              ref="SYAKO_SYODAKUSYO_CHUSYAJYO_BANGO"
              class="col-md-3"
              maxlength="4"
              v-model="form.SYAKO_SYODAKUSYO_CHUSYAJYO_BANGO"
              :state="errors.length ? false : null"
              placeholder="1"
              trim
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr>
        <th>郵便番号</th>
        <td>
          <div class="row">
            <div class="col-4 col-md-3">
              <validation-provider
                v-slot="{ errors }"
                rules="numeric|digits:3"
                name="SYAKO_SYODAKUSYO_YUBIN1"
              >
                <b-form-input
                  type="tel"
                  ref="SYAKO_SYODAKUSYO_YUBIN1"
                  maxlength="3"
                  v-model="form.SYAKO_SYODAKUSYO_YUBIN1"
                  :state="errors.length ? false : null"
                  placeholder="160"
                  trim
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <span class="py-2">-</span>
            <div class="col-4 col-md-3">
              <validation-provider
                v-slot="{ errors }"
                rules="numeric|digits:4"
                name="SYAKO_SYODAKUSYO_YUBIN2"
              >
                <b-form-input
                  type="tel"
                  ref="SYAKO_SYODAKUSYO_YUBIN2"
                  maxlength="4"
                  v-model="form.SYAKO_SYODAKUSYO_YUBIN2"
                  :state="errors.length ? false : null"
                  placeholder="0023"
                  trim
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <button
              type="button"
              class="btn btn-success bold"
              @click="searchAddress"
              :disabled="!isYubinSearch"
              style="height: 40px"
            >
              検索
            </button>
          </div>
        </td>
      </tr>
      <tr>
        <th>都道府県・市区郡</th>
        <td>
          <div class="row">
            <div class="col-4 col-md-4 col-lg-3 pr-0">
              <validation-provider
                v-slot="{ errors }"
                name="SYAKO_SYODAKUSYO_TODO_CD"
                ref="SYAKO_SYODAKUSYO_TODO_MEI"
              >
                <b-form-select
                  v-model="form.SYAKO_SYODAKUSYO_TODO_CD"
                  ref="SYAKO_SYODAKUSYO_TODO_CD"
                  :state="errors.length ? false : null"
                  :options="prefList"
                  trim
                  @change="changePref"
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <div class="col-7 col-md-5 col-lg-4">
              <validation-provider
                v-slot="{ errors }"
                name="SYAKO_SYODAKUSYO_SHIKU_CD"
                ref="SYAKO_SYODAKUSYO_SHIKU_MEI"
              >
                <b-form-select
                  :disabled="!cityList.length"
                  ref="SYAKO_SYODAKUSYO_SHIKU_CD"
                  v-model="form.SYAKO_SYODAKUSYO_SHIKU_CD"
                  :state="errors.length ? false : null"
                  :options="cityList"
                  trim
                  @change="changeCity"
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th>町名・番地</th>
        <td>
          <validation-provider
            name="SYAKO_SYODAKUSYO_BANCHI"
            v-slot="{ errors }"
            rules="max:25|char"
          >
            <b-form-input
              maxlength="25"
              ref="SYAKO_SYODAKUSYO_BANCHI"
              v-model="form.SYAKO_SYODAKUSYO_BANCHI"
              :state="errors.length ? false : null"
              placeholder="西新宿7－4－3 升本ビル4F"
              trim
              @blur="
                form.SYAKO_SYODAKUSYO_BANCHI = replaceChar(
                  form.SYAKO_SYODAKUSYO_BANCHI
                )
              "
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr>
        <th>TEL</th>
        <td>
          <validation-provider
            name="SYAKO_SYODAKUSYO_TEL"
            v-slot="{ errors }"
            rules="tel"
          >
            <b-form-input
              class="col-md-6"
              ref="SYAKO_SYODAKUSYO_TEL"
              maxlength="17"
              v-model="form.SYAKO_SYODAKUSYO_TEL"
              :state="errors.length ? false : null"
              placeholder="03-5937-4777"
              trim
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
        </td>
      </tr>
      <tr>
        <th>取寄せ先情報</th>
        <td>
          <div class="row">
            <div class="col-md-12">
              <validation-provider
                v-slot="{ errors }"
                name="SYAKO_SYODAKUSYO_TORIYOSE"
                rules="max:200|char"
              >
                <b-form-textarea
                  ref="SYAKO_SYODAKUSYO_TORIYOSE"
                  v-model="form.SYAKO_SYODAKUSYO_TORIYOSE"
                  :state="errors.length ? false : null"
                  trim
                  maxlength="200"
                  @blur="
                    form.SYAKO_SYODAKUSYO_TORIYOSE = replaceChar(
                      form.SYAKO_SYODAKUSYO_TORIYOSE
                    )
                  "
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Mixin from '@/components/mixin/Mixin'
import Constant from '@/const'
import Store from '@/store/index.js'
import _ from 'lodash'

export default {
  name: 'GarageConsent',

  mixins: [Mixin],

  props: {
    /** データ取得フラグ */
    isGetData: {
      type: Boolean,
      default: false,
    },

    /** データ設定フラグ */
    isSetData: {
      type: Boolean,
      default: false,
    },

    /** オブザーバー */
    observer: {
      type: Object,
      default: null,
    },

    /** 親入力データ */
    parent: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    /** 市区町村リスト */
    cityList: [],

    /** 入力データ */
    form: {
      SYAKO_SYODAKUSYO_FLG: 0,
      SYAKO_SYODAKUSYO_TORIYOSE_FLG: 0,
      SYAKO_SYODAKUSYO_TORIYOSE: null,
      SYAKO_SYODAKUSYO_CHUSYAJYO_KEIYAKU_MEI: null,
      SYAKO_SYODAKUSYO_CHUSYAJYO_MEI: null,
      SYAKO_SYODAKUSYO_CHUSYAJYO_BANGO: null,
      SYAKO_SYODAKUSYO_YUBIN1: null,
      SYAKO_SYODAKUSYO_YUBIN2: null,
      SYAKO_SYODAKUSYO_TODO_CD: null,
      SYAKO_SYODAKUSYO_TODO_MEI: null,
      SYAKO_SYODAKUSYO_SHIKU_CD: '',
      SYAKO_SYODAKUSYO_SHIKU_MEI: null,
      SYAKO_SYODAKUSYO_BANCHI: null,
      SYAKO_SYODAKUSYO_TEL: null,
    },
  }),

  methods: {
    /** 入力データを精設定する */
    setData() {
      if (this.parent) {
        for (var name in this.form) {
          if (this.parent[name] !== undefined)
            this.form[name] = this.parent[name]
        }
        this.getCityList()
      }
    },

    /** 都道府県変更 */
    changePref() {
      const todoCd = this.form.SYAKO_SYODAKUSYO_TODO_CD
      this.form.SYAKO_SYODAKUSYO_TODO_MEI = null
      this.form.SYAKO_SYODAKUSYO_SHIKU_CD = ''
      this.form.SYAKO_SYODAKUSYO_SHIKU_MEI = null
      if (todoCd) {
        this.form.SYAKO_SYODAKUSYO_TODO_MEI = this.getText(
          this.prefList,
          todoCd
        )
        this.getCityList()
      } else this.cityList = []
    },

    /** 市区町村変更 */
    changeCity() {
      const shikuCd = this.form.SYAKO_SYODAKUSYO_SHIKU_CD
      this.form.SYAKO_SYODAKUSYO_SHIKU_MEI = null
      if (shikuCd) {
        this.form.SYAKO_SYODAKUSYO_SHIKU_MEI = this.getText(
          this.cityList,
          shikuCd
        )
      }
    },

    /** 市区町村リスト取得 */
    getCityList() {
      if (!this.form.SYAKO_SYODAKUSYO_TODO_CD) return
      return Store.dispatch(
        'address/getCityList',
        this.form.SYAKO_SYODAKUSYO_TODO_CD
      ).then(() => {
        const cityList = _.cloneDeep(Store.state.address.cityList)
        cityList.unshift({
          value: '',
          text: '未選択',
        })
        this.cityList = cityList
      })
    },

    /** 郵便番号検索 */
    searchAddress() {
      this.getAreaFromZipCd(
        `${this.form.SYAKO_SYODAKUSYO_YUBIN1}${this.form.SYAKO_SYODAKUSYO_YUBIN2}`
      ).then(async (item) => {
        if (item) {
          this.form.SYAKO_SYODAKUSYO_TODO_CD = ('00' + item.prefcode).slice(-2)
          this.form.SYAKO_SYODAKUSYO_TODO_MEI = this.getText(
            this.prefList,
            this.form.SYAKO_SYODAKUSYO_TODO_CD
          )
          this.form.SYAKO_SYODAKUSYO_SHIKU_MEI = item.address2
          this.form.SYAKO_SYODAKUSYO_BANCHI = item.address3
          await this.getCityList()
          const city = this.getParam(
            this.cityList,
            this.form.SYAKO_SYODAKUSYO_SHIKU_MEI,
            'text'
          )
          if (city) this.form.SYAKO_SYODAKUSYO_SHIKU_CD = city.value
        }
      })
    },

    /** 表示された入力データのみ設定する */
    cleanup() {
      let d = _.cloneDeep(this.form)
      for (var name in d) {
        if (!this.$refs[name]) delete d[name]
      }
      return d
    },
  },

  computed: {
    /** 郵便検索可能か */
    isYubinSearch() {
      return (
        this.form.SYAKO_SYODAKUSYO_YUBIN1 &&
        this.form.SYAKO_SYODAKUSYO_YUBIN2 &&
        this.observer &&
        this.observer.fields.SYAKO_SYODAKUSYO_YUBIN1 &&
        this.observer.fields.SYAKO_SYODAKUSYO_YUBIN2 &&
        !this.observer.fields.SYAKO_SYODAKUSYO_YUBIN1.failed &&
        !this.observer.fields.SYAKO_SYODAKUSYO_YUBIN2.failed
      )
    },
  },

  watch: {
    /* データ取得フラグ監視 */
    async isGetData(val) {
      if (val) this.$emit('setData', this.cleanup())
    },

    /* データ設定フラグ監視 */
    async isSetData(val) {
      if (val) this.setData()
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../../assets/css/logico2'
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
    padding: 1.5%
  td
    width: 68%
    background: #fff
</style>



// WEBPACK FOOTER //
// src/components/order/meihen/GarageConsent.vue